import { ColDef } from "ag-grid-community";

import { ColumnType } from "components/AgGrid/constants";

import { formatters, getters } from "lib/agGrid";

import { BuyerPaymentSummaryItem } from "constants/payments";

export enum BuyerPaymentSummaryColId {
  LOT_TITLE = "b6a1a6b1-37df-4e3f-9b8b-cc8f4f9b2b9f",
  QTY = "4d5215d0-8701-4e02-b8c5-4f2d1e2a8d66",
  AMOUNT_INCL = "a8d6d81d-4f7f-4b7b-b2a8-2b3b9b1d2f9a",
}

export const BuyerPaymentSummaryColumnDef: Record<
  string,
  ColDef<BuyerPaymentSummaryItem>
> = {
  [BuyerPaymentSummaryColId.LOT_TITLE]: {
    colId: BuyerPaymentSummaryColId.LOT_TITLE,
    headerName: "Lot Title",
    field: "lotTitle",
    flex: 1,
    minWidth: 200,
  },
  [BuyerPaymentSummaryColId.QTY]: {
    colId: BuyerPaymentSummaryColId.QTY,
    headerName: "Qty",
    field: "quantity",
    width: 70,
  },
  [BuyerPaymentSummaryColId.AMOUNT_INCL]: {
    colId: BuyerPaymentSummaryColId.AMOUNT_INCL,
    headerName: "Amount incl ($)",
    field: "amountInclCents",
    valueGetter: getters.dollarsGetter,
    valueFormatter: formatters.dollarsFormatterWithCents,
    width: 140,
    type: ColumnType.RIGHT_ALIGNED,
  },
};

export const BuyerPaymentSummaryLotColumnDefs: Array<
  ColDef<BuyerPaymentSummaryItem>
> = [
  BuyerPaymentSummaryColumnDef[BuyerPaymentSummaryColId.LOT_TITLE],
  BuyerPaymentSummaryColumnDef[BuyerPaymentSummaryColId.QTY],
  BuyerPaymentSummaryColumnDef[BuyerPaymentSummaryColId.AMOUNT_INCL],
];
